/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Create_Error1Inputs */

const vi_driverremittance_create_error1 = /** @type {(inputs: Driverremittance_Create_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tạo phiếu nộp quỹ.`)
};

/**

* @param {Driverremittance_Create_Error1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_create_error1 = /** @type {((inputs?: Driverremittance_Create_Error1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Create_Error1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_create_error1(inputs)
});
export { driverremittance_create_error1 as "driverRemittance_create_error" }